module.exports = __webpack_public_path__ + "static/media/ic_benefit_bonus.6213b4b4.png";